import React from 'react';

const HomeProtectionIcon = props => (
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 42 42"
    className={props.className}
  >
    <g>
      <path
        style={{ fill: '#969696' }}
        d="M16.7,22.1H8.9c-0.5,0-0.9-0.4-0.9-0.9V10.9c0-0.5,0.3-1.1,0.7-1.4l1.5-1V5.3h2.2v1.8l3.6-2.4
      c0.2-0.1,0.5-0.2,0.7-0.2c0.3,0,0.5,0.1,0.7,0.2l7.3,4.8c0.4,0.3,0.7,0.9,0.7,1.4v3.8l0.2-0.1c0.1-0.1,0.3-0.1,0.5-0.1
      c0.1,0,0.2,0,0.4,0.1v-3.7c0-0.8-0.5-1.8-1.2-2.3l-7.3-4.8c-0.4-0.2-0.8-0.4-1.3-0.4c-0.5,0-0.9,0.1-1.3,0.4l-2,1.3V4.3h-1.1h-2.2
      H9.2v1.1V8l-1,0.7C7.5,9.1,7,10.1,7,10.9v10.2c0,1.1,0.9,1.9,1.9,1.9h7.8V22.1z"
      />
      <path
        style={{ fill: '#32B496' }}
        d="M26.3,38.5c-0.1,0-0.2,0-0.2-0.1c-0.3-0.2-0.6-0.4-0.8-0.5c-1.7-1.1-3.5-2.3-4.8-3.5c-1.9-1.7-2.8-3.3-2.8-5
      V19.3c0-0.2,0.1-0.3,0.3-0.4l8.3-3.1c0.1,0,0.2,0,0.3,0l8.3,3.1c0.2,0.1,0.3,0.2,0.3,0.4v10.1c0,1.7-0.9,3.3-2.8,5
      c-1.4,1.2-3.1,2.4-4.8,3.5c-0.3,0.2-0.6,0.4-0.8,0.5C26.5,38.5,26.4,38.5,26.3,38.5"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M33.2,29.4v-2.7H19.3v2.7c0,1.2,0.7,2.3,2.2,3.7c1.3,1.1,3,2.3,4.6,3.3l0,0l0.1,0l0.1-0.1
      c1.6-1.1,3.4-2.2,4.6-3.3C32.5,31.7,33.2,30.6,33.2,29.4"
      />
    </g>
  </svg>
);

export default HomeProtectionIcon;
